import Accordion from 'accordion-js';

export async function init() {
  console.log('[initialized] accordion.ts');
  const accordions = document.querySelectorAll('.accordion');
  accordions.forEach((accordion) => {
    const showSingle = (accordion as HTMLElement).dataset.showSingle;
    new Accordion(accordion, {
      duration: 400,
      showMultiple: showSingle === 'true' ? false : true,
    });
  });
}
